import { BehaviorSubject, catchError, concatMap, forkJoin, map, merge, Observable, of, Subscription, switchMap, tap, timer } from 'rxjs';
import { AuthService } from './../../service/auth.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractDto, AgentDto, TicketBundleDto, TicketDto, ResultListDto, WorkflowDto, WorkflowStepDto, WorkflowStepStatusDto } from '../../service/dto';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { HttpTicketService } from '../../service/http-ticket.service';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
	selector: 'app-home',
	standalone: false,
	templateUrl: './home.component.html',
	styleUrl: './home.component.scss'
})
export class HomeComponent{

}
